import Main from "../src/layout/Main/Main";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
